import React, { useState } from "react";
import { CellTmpl, reactFormatter, NameTmpl, DEFAULT_OPTIONS_PAYLOAD } from "../../../common/Table";
import CityDetails from "./CityDetails";
import { useGetCities, useDeleteCity, useGetStates } from "../../../../backend/masters";
import { GetMastersBreadcrumb } from "../Master.constants";
import { useExportCities } from "../../../../backend/exports";
import BaseList from "../../../common/BaseList";
import AddEditCity from "./AddEditCity";
import { CitySchema } from "../../../../models/city";

const CITIES_DEFAULT_PAYLOAD = {
    sorts: ['updated_at desc'],
    includes: ['state'],
    include: {
      state: {
        only: ['id','name']
      }
    }
  }

function City() {
    const [breadcrumb] = useState(GetMastersBreadcrumb('City'));
    const { states } = useGetStates({ ...DEFAULT_OPTIONS_PAYLOAD });
    
    const columns = [
        { title: "Code", field: "code", formatter: reactFormatter(<CellTmpl />) },
        { title: "Name", field: "name", widthGrow: 2, formatter: reactFormatter(<CellTmpl />) },
        { title: "State", field: "state", widthGrow: 2, formatter: reactFormatter(<NameTmpl />) }
    ]

    const filterConfig = [
      {
          label: 'State',
          name: 'state_id_eq',
          options: (states || []).map((x: any) => {
              return { value: x.id, label: x.name };
          })
      }
    ];

    return (
        <BaseList
            fetchData={useGetCities}
            exportData={useExportCities}
            deleteData={useDeleteCity}
            nameAttribute={'name'}
            columns={columns}
            DetailView={CityDetails}
            FormView={AddEditCity}
            modelSchema={CitySchema}
            initialSort={['name asc']}
            breadcrumb={breadcrumb}
            initialPayload={CITIES_DEFAULT_PAYLOAD}
            filterConfig={filterConfig}
            title="Mastsers - Cities"
        />
    )
}

export default City;
